import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: {},
    error: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        isProgress: true,
      };
    case homeConstants.FORGOT_PASSWORD_SUCCESS:
      return {
        data: action.response.data,
        isProgress: false,
      };
    case homeConstants.FORGOT_PASSWORD_FAILURE:
      return {
        data: {},
        error: action.error,
        isProgress: false,
      };
    case homeConstants.RESET_DATA:
      return {
        ...state,
        data: {},
      };
    default:
      return state;
  }
}
